export const GridSchema = (props) => {
  return {
    title: 'Sliding Text Block',
    block: '__grid',
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },
    ],

    properties: {},
    required: [],
  };
};
